import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type UpcomingDraws = Static<typeof UpcomingDrawsSchema>;
export const UpcomingDrawsSchema = Type.Array(
  Type.Object(
    {
      drawNo: Type.Integer({ minimum: 1 }),
      startDate: Type.String({ format: 'date-time' }),
      endDate: Type.String({ format: 'date-time' }),
      drawDate: Type.String({ format: 'date-time' }),
      signups: Type.Optional(Type.Integer({ minimum: 0 })),
    },
    { additionalProperties: false, $id: 'UpcomingDrawsSchema' }
  )
);
